import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  id: "doms",
  class: "h-[64px] px-[20px] flex items-center justify-between",
  style: {"border-bottom":"1px solid #e5e5e5"}
}
const _hoisted_3 = { class: "content flex h-[calc(100vh-64px)]" }
const _hoisted_4 = { class: "leftpanel w-[300px] h-full px-[20px] py-[20px]" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = {
  key: 0,
  class: "rightpanel flex-1 h-full"
}
const _hoisted_7 = {
  key: 1,
  class: "custom-thin rightpanel flex-1 h-full"
}

import { onMounted, nextTick, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox } from 'element-plus'
import { initGlobalConfig } from '@/common/initGlobalConfig'
import { initClient } from '@/common/inituser'
import { useMiscStore } from '@/stores/misc'
import { useUserStore } from '@/stores/user'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
//@ts-ignore
import team from '@/components/topPanel/team/team.vue'
//@ts-ignore
import login from '@/components/topPanel/login/login.vue'
//@ts-ignore
import size from '@/components/fileActions/createDesign/size.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const router = useRouter();
const route = useRoute()
const showTeamChild = ref(false)
const rightpanelshow = ref(false)
const userStore = useUserStore()
const currentTeam = ref<any>({})
const islogin = userStore.isLoggedIn
const dialogVisible = ref(false)

onMounted(async () => {
  await initGlobalConfig()
  await initClient()
  const miscStore = useMiscStore()
  currentTeam.value = userStore.currentTeamInfo
  if (!islogin) {
    (window as any).openGlobalLogin?.()
    return
  };
  rightpanelshow.value = true
  // // @ts-ignore
  // Auth.ins.ready((res) => {
  //   let doms = document.getElementById("doms");

  //   //@ts-ignore
  //   // Auth.user.getUserInfo({
  //   //   onSuccess: (data) => {
  //   //     //@ts-ignore
  //   //     Auth.header.init({
  //   //       insertDom: doms,
  //   //       clientId: miscStore.getClientID(),
  //   //       mask: 1,
  //   //       info: data,
  //   //       supportGroup: true,
  //   //       is_vip: false,
  //   //     });
  //   //     rightpanelshow.value = true

  //   //   },
  //   // });
  // });
});
const jump = (path: string) => {
  router.push({ path })
}
const createdesign = () => {
  dialogVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_User = _resolveComponent("User")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (rightpanelshow.value)
          ? (_openBlock(), _createBlock(team, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(login)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "",
          onClick: createdesign
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, { size: "16" }, {
              default: _withCtx(() => [
                _createVNode(_component_EditPen)
              ]),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "name" }, "创建设计", -1))
          ])
        ]),
        _createElementVNode("div", {
          class: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (jump('/home')))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["item", { 'itemactive': _unref(route).path === '/home' }])
          }, [
            _createVNode(_component_el_icon, { size: "16" }, {
              default: _withCtx(() => [
                _createVNode(_component_User)
              ]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "name" }, "我的空间", -1))
          ], 2)
        ]),
        _createElementVNode("div", {
          class: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (jump('/home/team')))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["item", { 'itemactive': _unref(route).path === '/home/team' }])
          }, [
            _createVNode(_component_el_icon, { size: "16" }, {
              default: _withCtx(() => [
                _createVNode(_component_MessageBox)
              ]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "name" }, _toDisplayString('团队空间'), -1))
          ], 2)
        ])
      ]),
      (rightpanelshow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_router_view)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(NewLoading, { fullscreen: "" })
          ]))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "",
      width: "430",
      top: "100px",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(size, {
          onCreate: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})